export enum EButtonColor {
	BLUE = 'blue',
	CYAN = 'cyan',
	PURPLE = 'purple',
	ORANGE = 'orange',
	GREEN = 'green',
	GRAY = 'gray',
	SILVER = 'silver',
	GOLD = 'gold',
	DIAMOND = 'diamond'
}
